export default __webpack_public_path__ + "static/media/icn-wtd-avg-service.0a95e354.svg";